"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOPPING_BAG_ICON_ROOT = void 0;
const SHOPPING_BAG_ICON_ROOT = exports.SHOPPING_BAG_ICON_ROOT = 'shopping-bag-icon-root';